module.exports = __webpack_public_path__ + "static/media/ferris.882662e8.webp";